var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86057",
    "data-name": "Group 86057",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.168,
    height: 24.69,
    viewBox: "0 0 21.168 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25106",
    "data-name": "Rectangle 25106",
    width: 21.168,
    height: 24.69,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86056",
    "data-name": "Group 86056",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242440",
    "data-name": "Path 242440",
    d: "M7.54,21.469H.87A.868.868,0,0,1,0,20.6V.871A.869.869,0,0,1,.867,0H15.495a.869.869,0,0,1,.871.867v9.392a.389.389,0,0,1-.777,0V.871a.1.1,0,0,0-.1-.1H.87a.1.1,0,0,0-.1.1V20.6a.1.1,0,0,0,.1.1H7.54a.385.385,0,1,1,0,.77Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242441",
    "data-name": "Path 242441",
    d: "M4.621,12.368a.388.388,0,0,1-.388-.388,3.949,3.949,0,0,1,6.743-2.793,4.019,4.019,0,0,1,.636.831.387.387,0,1,1-.67.388A3.184,3.184,0,0,0,5,11.986a.368.368,0,0,1-.353.382Z",
    fill: "#ff6464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242442",
    "data-name": "Path 242442",
    d: "M8.183,7.138a2.1,2.1,0,1,1,2.1-2.1,2.1,2.1,0,0,1-2.1,2.1m0-3.435A1.333,1.333,0,1,0,9.516,5.036,1.333,1.333,0,0,0,8.183,3.7Z",
    fill: "#ff6464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242443",
    "data-name": "Path 242443",
    d: "M13.554,24.69a7.654,7.654,0,0,1-2.967-.6A7.49,7.49,0,0,1,8.17,22.46a7.6,7.6,0,0,1-1.634-8.351A7.49,7.49,0,0,1,8.17,11.692a7.79,7.79,0,0,1,2.417-1.634,7.68,7.68,0,0,1,5.934,0,7.49,7.49,0,0,1,2.417,1.634,7.6,7.6,0,0,1,1.634,8.35,7.494,7.494,0,0,1-1.634,2.418,7.721,7.721,0,0,1-2.417,1.634,7.614,7.614,0,0,1-2.967.6m0-14.458A6.844,6.844,0,1,0,20.4,17.076,6.844,6.844,0,0,0,13.554,10.232Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242444",
    "data-name": "Path 242444",
    d: "M13.554,21.2a2.886,2.886,0,1,1,2.886-2.886A2.886,2.886,0,0,1,13.554,21.2Zm0-5.009a2.116,2.116,0,1,0,2.116,2.116,2.116,2.116,0,0,0-2.116-2.116",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242445",
    "data-name": "Path 242445",
    d: "M13.554,22.447a4.135,4.135,0,0,1-3.08-6.9.384.384,0,0,1,.569.515,3.362,3.362,0,1,0,5.009,0,.384.384,0,0,1,.569-.515,4.132,4.132,0,0,1-.154,5.685,4.053,4.053,0,0,1-2.913,1.212",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242446",
    "data-name": "Path 242446",
    d: "M16.353,16.192a.388.388,0,0,1-.388-.388v-.556a1.514,1.514,0,0,0-1.511-1.514H12.663a1.513,1.513,0,0,0-1.513,1.511V15.8a.389.389,0,0,1-.777,0v-.556a2.287,2.287,0,0,1,2.284-2.284h1.794a2.287,2.287,0,0,1,2.284,2.284V15.8a.383.383,0,0,1-.378.388Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242447",
    "data-name": "Path 242447",
    d: "M16.353,16.192H13.561a.389.389,0,1,1,0-.777h2.792a.388.388,0,0,1,.388.389.392.392,0,0,1-.388.388",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242448",
    "data-name": "Path 242448",
    d: "M13.554,22.34a.388.388,0,0,1-.388-.388V20.88a.388.388,0,0,1,.776,0v1.072a.388.388,0,0,1-.388.388",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242449",
    "data-name": "Path 242449",
    d: "M14.505,13.741a.388.388,0,0,1-.388-.388v-.322a.566.566,0,0,0-1.132-.007v.322a.389.389,0,0,1-.777,0v-.322a1.341,1.341,0,0,1,2.284-.944,1.325,1.325,0,0,1,.388.944v.322a.371.371,0,0,1-.347.394h-.028",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242450",
    "data-name": "Path 242450",
    d: "M13.292,15.04h-.683a.389.389,0,0,1,0-.777h.683a.389.389,0,0,1,0,.777",
    fill: "#ff6464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.2cbc6f607cb9d8d260ea301ac8c288c5.svg";
export { ForwardRef as ReactComponent };